module.exports = __webpack_public_path__ + "img/set-up.88a95698.svg";